import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-dark-surface/95 backdrop-blur-md border-b border-dark-border"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="https://storage.readdy-site.link/project_files/ea9bd2f5-a5fa-48e1-adb8-14e6c6a8dddd/39001f87-94f8-4788-9d8a-585e79d11d93_logo.png?v=4a092eb770424da0016aa1f907a04388"
                alt="할매티비 스포츠중계"
                width="40"
                height="40"
                className="w-10 h-10 rounded-md"
              />
              <span className="text-white font-bold text-lg md:text-xl whitespace-nowrap">
                할매티비 스포츠중계
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className="text-white font-medium text-sm hover:text-brand-orange transition-colors whitespace-nowrap"
            >
              할매티비 스포츠중계
            </Link>
            <Link
              to="/sports-schedule"
              className="text-dark-text-muted font-medium text-sm hover:text-brand-orange transition-colors whitespace-nowrap"
            >
              오늘의 스포츠중계
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="메뉴 열기"
          >
            <i className={`ri-${isMobileMenuOpen ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-dark-surface border-t border-dark-border">
          <nav className="flex flex-col py-4 px-4">
            <Link
              to="/"
              className="text-white font-medium py-3 hover:text-brand-orange transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              할매티비 스포츠중계
            </Link>
            <Link
              to="/sports-schedule"
              className="text-dark-text-muted font-medium py-3 hover:text-brand-orange transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              오늘의 스포츠중계
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}